var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-page',[_c('div',{attrs:{"id":"contents"}},[_c('v-container',[_c('div',{staticClass:"title-wrap title-wrap--line"},[_c('h2',{staticClass:"font-42"},[_vm._v("라이브러리 게시판")])]),_c('library-list')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }